import React from "react"
import { Button, Modal } from "react-bootstrap"

function ConfirmActionModal({
  title, show, onHide, onConfirm, children,
  confirmLabel = "Send", confirmVariant = "primary", confirmDisabled = false
}) {
  return (
    <Modal backdrop="static" onHide={onHide} show={show} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant="secondary">Cancel</Button>
        <Button disabled={confirmDisabled} onClick={onConfirm} variant={confirmVariant}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmActionModal
